// extracted by mini-css-extract-plugin
export var svgBlack = "cj_jv";
export var svgInverted = "cj_j0";
export var svgReviewsIOLogo = "cj_jZ";
export var svgWhite = "cj_jt";